import { render, staticRenderFns } from "./UseCasesPopup.vue?vue&type=template&id=0e49dc0c&"
import script from "./UseCasesPopup.vue?vue&type=script&lang=ts&"
export * from "./UseCasesPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports